/// <amd-module name="Search/WorkItem/Components/LeftPane/TitleSection" />
import * as React from "react";
import { Link } from "VSSUI/Link";
import { css } from "VSSUI/Util";
import { WrappedComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { WorkItemRoute, Ref } from "Search/WorkItem/Constants";
import { IHighlightFragment } from "Search/WorkItem/Flux/Stores/SnippetFragmentCache";
import { sanitizeHtml } from "Search/WorkItem/Utils";
import { IVssPageContext } from "VSS/Platform/Context";

const { title, id, type } = Ref;

export interface ITitleSectionProps {
    fields: { [key: string]: string };

    project: string;

    index: number;

    aggregatedHits: { [key: string]: IHighlightFragment };

    idWidth: number;

    pageContext: IVssPageContext;

    onWorkItemInvoked(workItemId: number, index: number, url: string, openInNewTab: boolean): void;
}

export class TitleSection extends React.PureComponent<ITitleSectionProps> {
    public render(): JSX.Element {
        const { aggregatedHits, fields, project } = this.props;
        const wiTitle = sanitizeHtml(aggregatedHits[title] ? aggregatedHits[title].highlights[0] : fields[title]);
        const wiId = aggregatedHits[id] ? sanitizeHtml(aggregatedHits[id].highlights[0]) : fields[id];
        const wiType = fields[type];
        
        /* TODO: I would have the props send the class instead of the pixelWidth */
        let digitClass = "wi-large-digit-value";
        if (this.props.idWidth <= 11) {
            digitClass = "wi-one-digit-value";
        } else if (this.props.idWidth <= 19) {
            digitClass = "wi-two-digit-value";
        } else if (this.props.idWidth <= 27) {
            digitClass = "wi-three-digit-value";
        } else if (this.props.idWidth <= 35) {
            digitClass = "wi-four-digit-value";
        }

        return (
            <div className="workitem-title flex-row flex-center fontSizeMM">
                <WrappedComponent
                    dependencies={["ms.vss-search-web.workitem-type-icon-content"]}
                    wrappedType="workItemTypeIcon"
                    wrappedProps={{
                        projectName: project,
                        workItemTypeName: wiType
                    }}
                />
                <span className={css("workitem-id text-ellipsis flex-noshrink", digitClass)} dangerouslySetInnerHTML={{ __html: wiId }} />
                <Link className="wit-link link-text flex-row scroll-hidden"
                    tabIndex={undefined}
                    excludeFocusZone= {true}
                    excludeTabStop ={true}
                    ariaLabel={fields[title]}
                    onClick={this.onLinkClick}
                    removeUnderline={true}
                >
                    <div className="wit-link-text text-ellipsis" dangerouslySetInnerHTML={{ __html: wiTitle }} />
                </Link>
            </div>
        );
    }

    private onLinkClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        const wiId = this.props.fields[id];
        this.props.onWorkItemInvoked(Number(wiId), this.props.index, this.getEditWorkItemUrl(wiId), event.ctrlKey);
        event.preventDefault();
    }

    private getEditWorkItemUrl = (wokrItemId: string): string => {
        return routeUrl(
            this.props.pageContext,
            WorkItemRoute,
            {
                project: this.props.project,
                id: wokrItemId
            }
        );
    }
}
